import { CopiaDiarioObraUseCase } from "../../../features/diarioObra/domain/useCases/create/copia_diario_obra_use_case";
import { CreateDiarioObraAtividadesUseCase } from "../../../features/diarioObra/domain/useCases/create/create_diario_obra_atividades_use_case";
import { CreateDiarioObraEfetivoUseCase } from "../../../features/diarioObra/domain/useCases/create/create_diario_obra_efetivo_use_case";
import { CreateDiarioObraEquipamentoUseCase } from "../../../features/diarioObra/domain/useCases/create/create_diario_obra_equipamento_use_case";
import { CreateDiarioObraImagensUseCase } from "../../../features/diarioObra/domain/useCases/create/create_diario_obra_imagens_use_case";
import { CreateDiarioObraParalisacoesUseCase } from "../../../features/diarioObra/domain/useCases/create/create_diario_obra_paralisacoes_use_case";
import { CreateDiarioObraUseCase } from "../../../features/diarioObra/domain/useCases/create/create_diario_obra_use_case";
import { DeleteDiarioObraAtividadesUseCase } from "../../../features/diarioObra/domain/useCases/delete/delete_diario_obras_atividades_use_case";
import { DeleteDiarioObraEfetivoUseCase } from "../../../features/diarioObra/domain/useCases/delete/delete_diario_obras_efetivo_use_case";
import { DeleteDiarioObraEquipamentoUseCase } from "../../../features/diarioObra/domain/useCases/delete/delete_diario_obras_equipamento_use_case";
import { DeleteDiarioObraImagensUseCase } from "../../../features/diarioObra/domain/useCases/delete/delete_diario_obras_imagens_use_case";
import { DeleteDiarioObraParalisacoesUseCase } from "../../../features/diarioObra/domain/useCases/delete/delete_diario_obras_paralisacoes_use_case";
import { DeleteDiarioObraUseCase } from "../../../features/diarioObra/domain/useCases/delete/delete_diario_obras_use_case";
import { GetAllDiarioObrasAtividadesServicoUseCase } from "../../../features/diarioObra/domain/useCases/read/get_all_diario_obras_atividades_use_case";
import { GetAllDiarioObrasEfetivoServicoUseCase } from "../../../features/diarioObra/domain/useCases/read/get_all_diario_obras_efetivo_use_case";
import { GetAllDiarioObrasEquipamentoServicoUseCase } from "../../../features/diarioObra/domain/useCases/read/get_all_diario_obras_equipamento_use_case";
import { GetAllDiarioObrasImagensServicoUseCase } from "../../../features/diarioObra/domain/useCases/read/get_all_diario_obras_imagens_use_case";
import { GetAllIndicadoresUseCase } from "../../../features/diarioObra/domain/useCases/read/get_all_diario_obras_indicador_use_case";
import { GetAllDiarioObrasParalisacoesServicoUseCase } from "../../../features/diarioObra/domain/useCases/read/get_all_diario_obras_paralisacoes_use_case";
import { GetAllDiarioObrasServicoUseCase } from "../../../features/diarioObra/domain/useCases/read/get_all_diario_obras_use_case";
import { AprovarDiarioObraUseCase } from "../../../features/diarioObra/domain/useCases/update/aprovar_diario_obra_use_case";
import { UpdateDiarioObraAtividadesUseCase } from "../../../features/diarioObra/domain/useCases/update/update_diario_obra_atividades_use_case";
import { UpdateDiarioObraEfetivoUseCase } from "../../../features/diarioObra/domain/useCases/update/update_diario_obra_efetivo_use_case";
import { UpdateDiarioObraEquipamentoUseCase } from "../../../features/diarioObra/domain/useCases/update/update_diario_obra_equipamento_use_case";
import { UpdateDiarioObraImagensUseCase } from "../../../features/diarioObra/domain/useCases/update/update_diario_obra_imagens_use_case";
import { UpdateDiarioObraParalisacoesUseCase } from "../../../features/diarioObra/domain/useCases/update/update_diario_obra_paralisacoes_use_case";
import { UpdateDiarioObraUseCase } from "../../../features/diarioObra/domain/useCases/update/update_diario_obra_use_case";
import { ICopiaDiarioObraUseCase } from "../../../features/diarioObra/presentation/useCases/create/copia_diario_obra_use_case";
import { ICreateDiarioObraAtividadesUseCase } from "../../../features/diarioObra/presentation/useCases/create/create_diario_obra_atividades_use_case";
import { ICreateDiarioObraEfetivoUseCase } from "../../../features/diarioObra/presentation/useCases/create/create_diario_obra_efetivo_use_case";
import { ICreateDiarioObraEquipamentoUseCase } from "../../../features/diarioObra/presentation/useCases/create/create_diario_obra_equipamento_use_case";
import { ICreateDiarioObraImagensUseCase } from "../../../features/diarioObra/presentation/useCases/create/create_diario_obra_imagens_use_case";
import { ICreateDiarioObraParalisacoesUseCase } from "../../../features/diarioObra/presentation/useCases/create/create_diario_obra_paralisacoes_use_case";
import { ICreatDiarioObraUseCase } from "../../../features/diarioObra/presentation/useCases/create/create_diario_obra_use_case";
import { IDeleteDiarioObraAtividadesUseCase } from "../../../features/diarioObra/presentation/useCases/delete/delete_diario_obras_atividades_use_case";
import { IDeleteDiarioObraEfetivoUseCase } from "../../../features/diarioObra/presentation/useCases/delete/delete_diario_obras_efetivo_use_case";
import { IDeleteDiarioObraEquipamentoUseCase } from "../../../features/diarioObra/presentation/useCases/delete/delete_diario_obras_equipamento_use_case";
import { IDeleteDiarioObraImagensUseCase } from "../../../features/diarioObra/presentation/useCases/delete/delete_diario_obras_imagens_use_case";
import { IDeleteDiarioObraParalisacoesUseCase } from "../../../features/diarioObra/presentation/useCases/delete/delete_diario_obras_paralisacoes_use_case";
import { IDeleteDiarioObraUseCase } from "../../../features/diarioObra/presentation/useCases/delete/delete_diario_obras_use_case";
import { IGetAllDiarioObrasAtividadesUseCase } from "../../../features/diarioObra/presentation/useCases/read/get_all_diario_obras_atividades_use_case";
import { IGetAllDiarioObrasEfetivoUseCase } from "../../../features/diarioObra/presentation/useCases/read/get_all_diario_obras_efetivo_use_case";
import { IGetAllDiarioObrasEquipamentoUseCase } from "../../../features/diarioObra/presentation/useCases/read/get_all_diario_obras_equipamento_use_case";
import { IGetAllDiarioObrasImagensUseCase } from "../../../features/diarioObra/presentation/useCases/read/get_all_diario_obras_imagens_use_case";
import { IGetAllIndicadoresUseCase } from "../../../features/diarioObra/presentation/useCases/read/get_all_diario_obras_indicadores_use_case";
import { IGetAllDiarioObrasParalisacoesUseCase } from "../../../features/diarioObra/presentation/useCases/read/get_all_diario_obras_paralisacoes_use_case";
import { IGetAllDiarioObrasUseCase } from "../../../features/diarioObra/presentation/useCases/read/get_all_diario_obras_use_case";
import { IAprovarDiarioObraUseCase } from "../../../features/diarioObra/presentation/useCases/update/aprovar_diario_obras_use_case";
import { IUpdateDiarioObraAtividadeUseCase } from "../../../features/diarioObra/presentation/useCases/update/update_diario_obras_atividades_use_case";
import { IUpdateDiarioObraEfetivoUseCase } from "../../../features/diarioObra/presentation/useCases/update/update_diario_obras_efetivo_use_case";
import { IUpdateDiarioObraEquipamentoUseCase } from "../../../features/diarioObra/presentation/useCases/update/update_diario_obras_equipamento_use_case";
import { IUpdateDiarioObraImagensUseCase } from "../../../features/diarioObra/presentation/useCases/update/update_diario_obras_imagens_use_case";
import { IUpdateDiarioObraParalisacoesUseCase } from "../../../features/diarioObra/presentation/useCases/update/update_diario_obras_paralisacoes_use_case";
import { IUpdateDiarioObraUseCase } from "../../../features/diarioObra/presentation/useCases/update/update_diario_obras_use_case";
import { useDiarioObrasRepositories } from "./use_repositories";
import { DownloadDiarioObraImagemUseCase } from "../../../features/diarioObra/domain/useCases/read/download_diario_obra_imagem_use_case";
import { IDownloadDiarioObraImagemUseCase } from "../../../features/diarioObra/presentation/useCases/read/download_diario_obra_imagem_use_case";
import { create } from "../../../common/utils/zustand_state_manager"; // {{ LAST DECL IMPORT }}

export type DiarioObraState = {

  //#region Diario Obras
  getAllListagemDiarioObrasUseCase: IGetAllDiarioObrasUseCase,
  aprovarDiarioObraUseCase: IAprovarDiarioObraUseCase,
  deleteDiarioObraUseCase: IDeleteDiarioObraUseCase,
  createDiarioObraUseCase: ICreatDiarioObraUseCase,
  copiaDiarioObraUseCase: ICopiaDiarioObraUseCase,
  updateDiarioObraUseCase: IUpdateDiarioObraUseCase,

  //#endregion

  //#region Efetivo
  getAllListagemEfetivoUseCase: IGetAllDiarioObrasEfetivoUseCase;
  createEfetivoUseCase: ICreateDiarioObraEfetivoUseCase,
  updateEfetivoUseCase: IUpdateDiarioObraEfetivoUseCase,
  deleteEfetivoUseCase: IDeleteDiarioObraEfetivoUseCase,

  //#endregion

  //#region Equipamento
  getAllListagemEquipamentoUseCase: IGetAllDiarioObrasEquipamentoUseCase;
  createEquipamentoUseCase: ICreateDiarioObraEquipamentoUseCase,
  updateEquipamentoUseCase: IUpdateDiarioObraEquipamentoUseCase,
  deleteEquipamentoUseCase: IDeleteDiarioObraEquipamentoUseCase,
  //#endregion

  //#region Atividades
  getAllListagemAtividadesUseCase: IGetAllDiarioObrasAtividadesUseCase;
  createAtividadesUseCase: ICreateDiarioObraAtividadesUseCase,
  updateAtividadesUseCase: IUpdateDiarioObraAtividadeUseCase,
  deleteAtividadesUseCase: IDeleteDiarioObraAtividadesUseCase,
  //#endregion

  //#region Paralisacoes
  getAllListagemParalisacoesUseCase: IGetAllDiarioObrasParalisacoesUseCase;
  createParalisacoesUseCase: ICreateDiarioObraParalisacoesUseCase,
  updateParalisacoesUseCase: IUpdateDiarioObraParalisacoesUseCase,
  deleteParalisacoesUseCase: IDeleteDiarioObraParalisacoesUseCase,
  //#endregion

  //#region Imagens
  getAllListagemImagensUseCase: IGetAllDiarioObrasImagensUseCase;
  createImagensUseCase: ICreateDiarioObraImagensUseCase,
  updateImagensUseCase: IUpdateDiarioObraImagensUseCase,
  deleteImagensUseCase: IDeleteDiarioObraImagensUseCase,
  downloadImagemUseCase: IDownloadDiarioObraImagemUseCase,
  //#endregion

  //#region Principal
  getAllIndicadoresUseCase: IGetAllIndicadoresUseCase,

  //#endregion
  // {{ LAST DECL INTERFACE }}
};

export const useDiarioObraUseCases = create<DiarioObraState>(() => {
  const { diarioObraRepository: repository } = useDiarioObrasRepositories.getState();
  return {

    //#region DiarioObras
    getAllListagemDiarioObrasUseCase: new GetAllDiarioObrasServicoUseCase(repository),
    deleteDiarioObraUseCase: new DeleteDiarioObraUseCase(repository),
    createDiarioObraUseCase: new CreateDiarioObraUseCase(repository),
    copiaDiarioObraUseCase: new CopiaDiarioObraUseCase(repository),
    updateDiarioObraUseCase: new UpdateDiarioObraUseCase(repository),
    aprovarDiarioObraUseCase: new AprovarDiarioObraUseCase(repository),


    //#endregion
    // {{ LAST DECL IMPLEMENTATION }}

    //#region Efetivo
    getAllListagemEfetivoUseCase: new GetAllDiarioObrasEfetivoServicoUseCase(repository),
    createEfetivoUseCase: new CreateDiarioObraEfetivoUseCase(repository),
    updateEfetivoUseCase: new UpdateDiarioObraEfetivoUseCase(repository),
    deleteEfetivoUseCase: new DeleteDiarioObraEfetivoUseCase(repository),
    //#endregion

    //#region Equipamento
    getAllListagemEquipamentoUseCase: new GetAllDiarioObrasEquipamentoServicoUseCase(repository),
    createEquipamentoUseCase: new CreateDiarioObraEquipamentoUseCase(repository),
    updateEquipamentoUseCase: new UpdateDiarioObraEquipamentoUseCase(repository),
    deleteEquipamentoUseCase: new DeleteDiarioObraEquipamentoUseCase(repository),
    //#endregion

    //#region Atividades
    getAllListagemAtividadesUseCase: new GetAllDiarioObrasAtividadesServicoUseCase(repository),
    createAtividadesUseCase: new CreateDiarioObraAtividadesUseCase(repository),
    updateAtividadesUseCase: new UpdateDiarioObraAtividadesUseCase(repository),
    deleteAtividadesUseCase: new DeleteDiarioObraAtividadesUseCase(repository),
    //#endregion

    //#region Paralisacoes
    getAllListagemParalisacoesUseCase: new GetAllDiarioObrasParalisacoesServicoUseCase(repository),
    createParalisacoesUseCase: new CreateDiarioObraParalisacoesUseCase(repository),
    updateParalisacoesUseCase: new UpdateDiarioObraParalisacoesUseCase(repository),
    deleteParalisacoesUseCase: new DeleteDiarioObraParalisacoesUseCase(repository),
    //#endregion

    //#region Imagens
    getAllListagemImagensUseCase: new GetAllDiarioObrasImagensServicoUseCase(repository),
    createImagensUseCase: new CreateDiarioObraImagensUseCase(repository),
    updateImagensUseCase: new UpdateDiarioObraImagensUseCase(repository),
    deleteImagensUseCase: new DeleteDiarioObraImagensUseCase(repository),
    downloadImagemUseCase: new DownloadDiarioObraImagemUseCase(repository),
    //#endregion

    //#region Principal
    getAllIndicadoresUseCase: new GetAllIndicadoresUseCase(repository),
    //#endregion
  };
});
